import IJitRepository from '../domain/IJitRepository';
import { RemarkMapper } from '../infrastructure/mappers/remark.mapper';
import jitRepository from '../infrastructure/repositories/JitRepository';

class CreateJitRemarkService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ body }: { body: any }) {
    const dto = RemarkMapper.toCreateDTO(body);
    return this._jitRepository.createJitRemark({ body: dto });
  }
}

export default new CreateJitRemarkService({
  repository: jitRepository
});

export { CreateJitRemarkService };
